import type { SegyHeaderCoordsType, SegyHeaderType } from '@core/core/types'

export type TextualHeaderType = {
  lines: string[]
}

type BinaryHeaderItemType = 'int32' | 'int16' | 'uint32' | 'uint16'

export type BaseHeaderRowType = {
  id: string
  position: number
  value?: number
  description: string
}

export type BaseHeaderRowTemplateType = {
  position: number
  type: BinaryHeaderItemType
  description: string
  postProcess?: (parseResult: number) => number
}

type BinaryHeaderRowType = BaseHeaderRowType
export type BinaryHeaderRowTemplateType = BaseHeaderRowTemplateType
export type TraceHeaderRowType = BinaryHeaderRowType
export type TraceHeaderRowTemplateType = BinaryHeaderRowTemplateType

export type BinaryHeaderType = BaseHeaderRowType[]
export type UseSegyParserType = {
  textualHeader: TextualHeaderType | undefined
  binaryHeader: BinaryHeaderType | undefined
  traceHeaders: TraceHeaderRowType[][] | undefined
  samplingStep: number | undefined
  samplesNumber: number | undefined
  formatCode: SegyHeaderType | undefined
  headersCoords: SegyHeaderCoordsType | undefined
  delayRecordingTime: number | undefined
}

export const FormatMappingKeysArray = [1, 2, 3, 5] as const
export type FormatMappingKeys = (typeof FormatMappingKeysArray)[number]
